console.log("script tac-consentementexplicite.js");

(function () {

    // 🔧 helper
    function qs(sel, root = document) {
        return root.querySelector(sel);
    }

    function qsa(sel, root = document) {
        return root.querySelectorAll(sel);
    }

    function wrapInner(el, wrapperHTML) {
        if (!el) return;
        el.innerHTML = wrapperHTML.replace("CONTENT", el.innerHTML);
    }

    function detach(el) {
        if (!el) return null;
        const parent = el.parentNode;
        if (!parent) return el;
        return parent.removeChild(el);
    }

    function insertBefore(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode);
    }

    function insertAfter(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }


    // =========================
    // 1. RESUME WRAP
    // =========================
    function ajoutBaliseResume() {
        const el = qs("#tarteaucitronDisclaimerAlert");
        if (!el) return;

        // équivalent wrapInner
        el.innerHTML = `<span id="tarteaucitron__resume">${el.innerHTML}</span>`;
    }


    // =========================
    // 2. TITRE MOBILE
    // =========================
    function deplacerTitreMobile() {
        const titre = qs("#tarteaucitronDisclaimerAlert b");
        const destination = qs("#tarteaucitronDisclaimerAlert");

        if (!titre || !destination) return;

        const detached = detach(titre);
        insertBefore(detached, destination);
    }


    function annulerDeplacerTitreMobileResize() {
        const titre = qs("#tarteaucitronAlertBig > b");
        const destination = qs("#tarteaucitron__resume");

        if (!titre || !destination) return;

        const detached = detach(titre);
        destination.prepend(detached);
    }


    function positionnerTitre() {

        function apply() {
            const width = document.body.offsetWidth;

            if (width < 751) {
                deplacerTitreMobile();
            } else {
                annulerDeplacerTitreMobileResize();
            }
        }

        // init
        apply();

        // resize
        window.addEventListener("resize", apply);
    }


    // =========================
    // 3. LIEN POLITIQUE DONNÉES
    // =========================
    function deplacerLienPolitiqueDonnees() {
        const lien = qs("#tarteaucitronPrivacyUrl");
        const destination = qs("#tarteaucitron__resume");

        if (!lien || !destination) return;

        const detached = detach(lien);
        insertAfter(detached, destination);
    }


    // =========================
    // 4. TOP BANDEAU
    // =========================
    function calculerTopBandeau() {
    const bandeau = qs("#uga__banner--deco");
    const hauteur = (bandeau ? bandeau.offsetHeight : 0) + 44;

    const el = qs(".tarteaucitronAlertBigBottom");
    if (el) el.style.top = hauteur + "px";
}


    function annulerTopBandeau() {
        qsa(".tarteaucitronAlertBigBottom").forEach(el => {
            el.style.top = "";
        });
    }


    function positionnerConsentementExpliciteMobile() {

        function apply() {
            const width = document.body.offsetWidth;

            if (width < 751) {
                calculerTopBandeau();
            } else {
                annulerTopBandeau();
            }
        }

        apply();
        window.addEventListener("resize", apply);
    }


    // =========================
    // 5. INIT TARTEAUCITRON
    // =========================
    window.addEventListener("tac.root_available", function () {

        setTimeout(() => {
            ajoutBaliseResume();
            positionnerTitre();
            deplacerLienPolitiqueDonnees();
            positionnerConsentementExpliciteMobile();
        }, 150);

    });

})();

